import { render, staticRenderFns } from "./pagination.vue?vue&type=template&id=3bc0579d&scoped=true&"
import script from "./pagination.vue?vue&type=script&lang=js&"
export * from "./pagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc0579d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bc0579d')) {
      api.createRecord('3bc0579d', component.options)
    } else {
      api.reload('3bc0579d', component.options)
    }
    module.hot.accept("./pagination.vue?vue&type=template&id=3bc0579d&scoped=true&", function () {
      api.rerender('3bc0579d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/memorandum/inbox/pagination/pagination.vue"
export default component.exports